<div class="content" role="alert" aria-live="polite">
    <div id="confirm-desc" class="title">{{confirmDialog.title}}</div>
    <div class="message">{{confirmDialog.message}}</div>
    <div class="message">{{confirmDialog.message3}}</div>
</div>
<div class="button-container">
    <button type="button" mat-raised-button color="white" *ngIf="confirmDialog.cancelButtonTitle" type="button"
        mat-dialog-close="cancel">{{confirmDialog.cancelButtonTitle}}</button>
        <button type="button" mat-raised-button color="primary" *ngIf="confirmDialog.thirdButtonTitle" type="button"
        mat-dialog-close="third">{{confirmDialog.thirdButtonTitle}}</button>
    <button type="button" mat-raised-button color="primary" *ngIf="confirmDialog.okButtonTitle" type="button"
        mat-dialog-close="ok">{{confirmDialog.okButtonTitle}}</button>
</div>